// @ts-strict-ignore
import { IOperation } from './i-operation';

export class BaseAdvancedOperation implements IOperation {
  private _additionalOperations: IOperation[];

  constructor(additionalOperations: IOperation[] = null) {
    this._additionalOperations = additionalOperations;
  }

  public getQualifiedClassName(): string {
    return 'BaseAdvancedOperation';
  }

  public getOperationDescription(): string {
    return '';
  }

  public get additionalOperations(): IOperation[] {
    return this._additionalOperations;
  }

  public set additionalOperations(operations: IOperation[]) {
    this._additionalOperations = operations;
  }

  public async performUndo(): Promise<void> {
    await this.undoAdditionalOperations();
  }

  public async performRedo(): Promise<void> {
    await this.redoAdditionalOperations();
  }

  protected async undoAdditionalOperations(): Promise<void> {
    if (!this._additionalOperations) {
      return;
    }
    for (const operation of this._additionalOperations) {
      await operation.performUndo();
    }
  }

  protected async redoAdditionalOperations(): Promise<void> {
    if (!this._additionalOperations) {
      return;
    }
    for (const operation of this._additionalOperations) {
      await operation.performRedo();
    }
  }
}
